const { webpackHotMiddleware } = require('./webpack-hot-middleware')

module.exports = {
  webpackHotMiddleware
}
